import styled from 'styled-components/macro';
import { LG } from '@zendeskgarden/react-typography';
import { Grid } from '@zendeskgarden/react-grid';
import { variables } from 'theme/variables';
import PublicPage from 'components/PublicPages/PublicPage';
import { Section } from 'components/PublicPages/GlobalPublicStyles';

const {
  color_white: colorWhite,
  spacing_sm: spacingSm,
  spacing,
  custom_blue: customBlue,
  public_font_size_sm: publicFontSizeSm,
} = variables;

export const BlogTemplatePage = styled(PublicPage)``;
// TODO: P2-790 style to make tabs and blogTypeHeader be sticky when scrolling.
export const StyledHeader = styled(Grid)`
  margin-top: 40px;
  #blogHeaders {
    display: flex;
    width: 50%;
    justify-content: center;
    margin-top: 10px;
    @media (max-width: 1900px) {
      width: 30%;
    }
    @media (max-width: 1440px) {
      width: 20%;
      margin-top: 20px;
    }
    @media (max-width: 1200px) {
      width: 100%;
    }
  }
`;

export const BlogTypeHeader = styled('h1')`
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 2.2rem;
`;

export const NavList = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`;

export const NavItem = styled.div`
  padding: 5px 15px;
  a {
    font-size: 15px !important;
    color: #000 !important;
    &.active-content-link {
      color: ${customBlue} !important;
      font-weight: bold !important;
      border-bottom: 2px solid ${customBlue};
    }
    &:hover {
      opacity: 0.8;
    }
  }
`;

export const ItemsTags = styled.div`
  max-width: 1200px;
  margin: 0 auto 40px;
  padding: 0 20px;
`;

export const TagList = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ccc;
`;

export const TagItem = styled.div`
  padding-right: 30px;
  a {
    font-size: 15px !important;
    color: #ccc !important;
    padding-bottom: 10px;
    position: relative;
    display: block;
    &.active-content-link {
      color: #000 !important;
      &:after {
        content: '';
        position: absolute;
        right: 0;
        left: 0;
        bottom: -1px;
        border-bottom: 2px solid #000;
      }
    }
    &:hover {
      opacity: 0.8;
    }
  }
`;

export const BlogPostsSection = styled(Section)`
  padding: 0 !important;
  padding-top: 60px !important;
  margin-bottom: 100px;
`;

export const Logo = styled(LG)`
  span {
    font-size: 32px;
    font-weight: bold;
    &.thin {
      font-weight: 300;
    }
  }
`;

export const BlogPostsSectionItems = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 1200px;
  margin: 0 auto;
  align-items: stretch;
`;

export const BlogWrapper = styled.div`
  position: relative;
  margin-bottom: 4px;
  padding: ${(props) => (props.small ? '0' : '20px')};
  max-width: ${(props) => (props.small ? '100%' : '33%')};
  width: 100%;
  ${(props) =>
    props.small
      ? `
    min-height: 100%;
    height: 100%;
    h2 {
      font-size: 22px !important;
      line-height: 33pximport { Grid } from '@zendeskgarden/react-grid';
;
    }
    `
      : `
    @media(max-width:900px) {
      max-width: 50%;
    }
    @media(max-width:600px) {
      max-width: 100%
    }
  `};
`;

export const BlogCard = styled.div`
  margin: 0 auto;
  max-width: 700px;
  border-radius: 6px;
  background-color: ${colorWhite};
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0px 3px 7px 0px rgba(10, 32, 83, 0.13);
  cursor: pointer;
  min-height: 200px;
  height: 100%;
  position: relative;
  * {
    cursor: pointer;
  }
`;
export const BlogPostHeader = styled.div`
  padding: 15px 20px;
`;

export const BlogPostWrapper = styled.div`
  padding: 20px 20px 40px 20px;
  h2 {
    margin-bottom: ${spacingSm};
    cursor: pointer;
    font-size: ${(props) => (props.small ? '18px' : '22px')};
  }
  h5 {
    margin-bottom: ${spacingSm};
    font-weight: normal;
    line-height: 34px;
    cursor: pointer;
    font-style: italic;
  }
  p {
    margin-bottom: ${spacing};
    font-size: ${(props) => (props.small ? '13px' : publicFontSizeSm)};
    line-height: ${(props) => (props.small ? '22px' : '25px')};
  }

  a {
    position: absolute;
    bottom: 20px;
  }
`;

export const BlogImgContainer = styled.div`
  width: 100%;
  height: ${(props) => (props.small ? '150px' : '200px')};
`;

export const BlogImg = styled.div`
  margin: 0 auto;
  display: block;
  width: 100%;
  height: 100%;
  background-image: url('${(props) => props.src}');
  background-size: cover;
  background-position: center;
  border-top-right-radius: ${(props) => (props.small ? '6px' : '0')};
  border-top-left-radius: ${(props) => (props.small ? '6px' : '0')};
`;

export const BackgroundImg = styled.img`
  overflow: hidden;
  position: absolute;
  height: auto;
`;

export const BackgroundCircle = styled.div`
  overflow: hidden;
  position: absolute;
  height: 1160px;
  width: 1160px;
  border: 200px solid rgba(1, 90, 208, 0.05);
  border-radius: 50%;
`;

export const BgCircleWrapper = styled.div`
  .left-circle {
    right: 77vw;
    bottom: 0;
    top: 728px;
    margin: 0 auto;
  }

  .right-circle {
    left: 79vw;
    bottom: 0;
    top: 20px;
    margin: 0 auto;
  }
`;
